import {Observable, of} from 'rxjs';
import {translationRu} from './translation-ru';
import {translationEn} from './translation-en';
import {translationAz} from './translation-az';
import {translationUk} from './translation-uk';

export class TranslationLoader {
  getTranslation(lang: string): Observable<any> {
    switch (lang) {
      case 'ru':
        return of(translationRu);
      case 'uk':
        return of(translationUk);
      case 'az':
        return of(translationAz);
      case 'en':
      default:
        return of(translationEn);
    }
  }
}
